import { Link } from "react-router-dom";
import { useApp } from "../../contexts/AppContext";

const NavigationBar = () => {
  const { theme, dispatch } = useApp();

  return (
    <nav className={`navigation-bar`}>
      <Link to={"/"}>
        <h1 className="navigation-bar__heading">Where in the world?</h1>
      </Link>
      <button
        className="navigation-bar__theme-toggle"
        onClick={() =>
          dispatch({
            type: "theme/changed",
            payload: theme === "dark" ? "light" : "dark",
          })
        }
      >
        {theme === "light" ? (
          <svg version="1.1" fill="#000" viewBox="0 0 384 512">
            <path
              d="M218.45,68C114.8,68,30.87,152.18,30.87,256s83.93,188,187.58,188c50.86,0,96.94-20.31,130.76-53.21
	c4.2-4.11,5.29-10.49,2.6-15.69s-8.48-8.14-14.27-7.13c-8.22,1.43-16.62,2.18-25.26,2.18c-81.33,0-147.29-66.14-147.29-147.71
	c0-55.23,30.21-103.32,74.95-128.66c5.12-2.94,7.72-8.81,6.46-14.52c-1.26-5.71-6.13-9.99-12-10.49
	c-5.29-0.42-10.58-0.67-15.95-0.67L218.45,68z"
            />
          </svg>
        ) : (
          <svg version="1.1" fill="#fff" viewBox="0 0 384 512">
            <path
              d="M284.1,256c0,49.9-40.3,92.1-92.1,92.1S99.9,307.8,99.9,256s42.2-92.1,92.1-92.1S284.1,206.1,284.1,256z M192,135.1
	c7.7,0,15.3-5.8,15.3-15.3V81.4c0-5.8-7.7-13.4-15.3-13.4s-15.3,5.8-15.3,15.3v38.4C176.7,129.4,184.3,135.1,192,135.1z
	 M287.9,175.4c3.8,0,7.7-1.9,9.6-3.8l26.9-26.9c5.8-5.8,5.8-15.3,0-21.1c-5.8-5.8-15.3-5.8-21.1,0l-26.9,26.9
	c-5.8,5.8-5.8,15.3,0,21.1C280.2,173.5,284.1,175.4,287.9,175.4L287.9,175.4z M364.7,240.7h-38.4c-7.7,0-15.3,5.8-15.3,15.3
	c0,9.6,5.8,15.3,15.3,15.3h38.4c7.7,0,15.3-5.8,15.3-15.3C380,246.4,372.3,240.7,364.7,240.7z M297.5,340.4
	c-5.8-5.8-15.3-5.8-21.1,0c-5.8,5.8-5.8,15.3,0,21.1l26.9,26.9c1.9,1.9,5.8,3.8,9.6,3.8s7.7-1.9,9.6-3.8c5.8-5.8,5.8-15.3,0-21.1
	L297.5,340.4L297.5,340.4z M192,374.9c-7.7,0-15.3,5.8-15.3,15.3v38.4c0,7.7,5.8,15.3,15.3,15.3c9.6,0,15.3-5.8,15.3-15.3v-38.4
	C207.3,382.6,199.7,374.9,192,374.9z M86.5,340.4l-26.9,26.9c-5.8,5.8-5.8,15.3,0,21.1c1.9,1.9,5.8,3.8,9.6,3.8s7.7-1.9,9.6-3.8
	l26.9-26.9c5.8-5.8,5.8-15.3,0-21.1C101.8,334.7,92.2,334.7,86.5,340.4L86.5,340.4z M73.1,256c0-7.7-7.7-15.3-15.3-15.3H19.3
	C11.7,240.7,4,246.4,4,256c0,9.6,5.8,15.3,15.3,15.3h38.4C65.4,269.4,73.1,263.7,73.1,256z M86.5,171.6c1.9,1.9,5.8,3.8,9.6,3.8
	s7.7-1.9,9.6-3.8c5.8-5.8,5.8-15.3,0-21.1l-24.9-26.9c-5.8-5.8-15.3-5.8-21.1,0c-5.8,5.8-5.8,15.3,0,21.1L86.5,171.6L86.5,171.6z"
            />
          </svg>
        )}
        <p>{theme === "light" ? "Dark Mode" : "Light Mode"}</p>
      </button>
    </nav>
  );
};

export default NavigationBar;
